import React, { useState, useEffect } from 'react';
import '../../assets/css/detalhes-internacao.css';
import { format } from 'date-fns';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import { Dialog as DialogPrime } from 'primereact/dialog';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Typography } from '@material-ui/core';
import Button from 'components/CustomButtons/Button';
import Checklist from './Checklist';

import { dominioLeanAspNetAPI } from '../../config/database';

export default function DetalhesInternacao(props) {
  const [internacao, setInternacao] = useState(null);
  const [abreChecklist, setAbreChecklist] = useState(false);
  const [carregar, setCarregar] = useState(false);

  const getInternacao = () => {
    const filtroInternacao = {
      seqLeito: props.leito.seqLeito,
    };

    setCarregar(true);

    dominioLeanAspNetAPI
      .post(`/api/detalharInternacao`, filtroInternacao)
      .then(response => {
        setInternacao(response.data);
      })
      .then(() => {
        setCarregar(false);
      });
  };

  useEffect(() => {
    getInternacao();
  }, [abreChecklist]);

  const handleSubmit = e => {
    e.preventDefault();
  };

  const voltarMapaLeito = () => {
    setAbreChecklist(false);
    props.fechaDetalhesInternacao(true);
  };

  if (carregar) {
    return <ProgressSpinner style={{ left: '45%' }} />;
  }

  return (
    <>
      <div>
        <Typography>
          Leito:
          {props.leito.numero}
        </Typography>
      </div>
      <br />
      <DialogPrime
        header="Checklist"
        visible={abreChecklist}
        style={{ width: '65vw' }}
        onHide={() => setAbreChecklist(false)}
      >
        <Checklist
          checklist={internacao?.checklist}
          setInternacao={setInternacao}
          internacao={internacao}
          leito={props.leito}
          voltarMapaLeito={voltarMapaLeito}
        />
      </DialogPrime>
      <form onSubmit={handleSubmit}>
        <Grid container direction="column" spacing={2}>
          <Grid item container direction="column" xs={8} sm={8} spacing={2}>
            <Grid item xs={8} sm={8}>
              <TextField
                autoComplete="off"
                name="ala"
                variant="outlined"
                fullWidth
                id="ala"
                label="Ala"
                InputLabelProps={{ shrink: true }}
                value={props.ala.nome}
                inputProps={{ maxLength: 9, style: { textTransform: 'uppercase' } }}
                disabled
                required
              />
            </Grid>
            <Grid item xs={8} sm={8}>
              <TextField
                autoComplete="off"
                name="nomePrestadora"
                variant="outlined"
                fullWidth
                id="nomePrestadora"
                label="Prestadora"
                InputLabelProps={{ shrink: true }}
                value={internacao ? internacao.nomePrestadora : undefined}
                inputProps={{ maxLength: 9, style: { textTransform: 'uppercase' } }}
                disabled
                required
              />
            </Grid>
          </Grid>
          <Grid item container xs={8} sm={8} spacing={2}>
            <Grid item xs={5} sm={5}>
              <Button
                disabled={props.leito.cor === '#BD1711'}
                style={{
                  width: '100%',
                }}
                onClick={() => setAbreChecklist(true)}
                color="info"
              >
                Checklist
              </Button>
            </Grid>
            <Grid item xs={3} sm={3}>
              <Button color="danger" onClick={() => props.fechaDetalhesInternacao()}>
                Voltar
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </>
  );
}
